// ----------------------------------------------------------------------------
// Component: Powertools Filtering
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_powertools-filter.scss';


//Product Filtering
$('body, html').on('click', '.filter-menu__popup__close', function(e){
    e.preventDefault();
    $('.filter-menu__popup').removeClass('active');

    window.filter_menu_open = false;
    $('body').removeClass('fixedHeight');
})

var filterClickCount = 0;

$('body, html').on('click', '.collection-container:not(.selected) a', function(e){

    if (filterClickCount == 0) {
      var tagName = $(this).text();
      window.dataLayer    = window.dataLayer || [];

      window.dataLayer.push({
          'event': 'filterTagsClick',
          'tagName': tagName
      });

      filterClickCount++;
    } else {
      filterClickCount = 0;
    }
})

$('.filter-menu__popup__trigger').on('click', function(e){
    e.preventDefault();

    if($('.filter-menu__popup').hasClass('active')){
        $('.filter-menu__popup').removeClass('active');

        window.filter_menu_open = false;
        //$('body').removeClass('fixedHeight');
    }else {
        $('.filter-menu__popup').addClass('active');
        window.filter_menu_open = true;
        //$('body').addClass('fixedHeight');
    }

})
